import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            影迷心声
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            看看在51影院追剧的影迷们怎么说
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {commentItems.map((comment) => (
            <div
              key={comment.name}
              className="rounded-2xl bg-background-50 p-5 md:p-6 border border-background-200"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${
                      i < comment.rating
                        ? 'ri-star-fill text-accent-500'
                        : 'ri-star-line text-foreground-300'
                    }`}
                  ></i>
                ))}
              </div>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                &ldquo;{comment.content}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                    onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800">
                    {comment.name}
                  </div>
                  <div className="text-xs text-foreground-500">{comment.date}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}